import store from '@/store'
import {
    getMenus
} from '@/api/system/menu'

export function getMenusFile(val) {
    return new Promise((resolve, reject) => {
        getMenus().then(res => {
            if (res.code == 200) {
                let datas = res.datas
                // 修改侧边栏路由
                let list = store.state.permission.sidebarRouters
                // 修改路由表路由
                let routerlist = val
                datas.forEach(item1 => {
                    list.forEach(item2 => {
                        if (item2.id && item2.id == item1.id) {
                            item2.meta = item1.meta
                            if (item2.children) {
                                item2 = changeMeta(item1, item2)
                            }
                        }
                    })
                    routerlist.forEach(item3 => {
                        if (item3.id && item3.id == item1.id) {
                            item3.meta = item1.meta
                            if (item3.children) {
                                item3 = changeMeta(item1, item3)
                            }
                        }
                    })
                });

                store.dispatch('ChangeSidebarRouters', list)
                resolve(routerlist)
            }

        })
    })
}

function changeMeta(value1, value2) {
    if (value1.children && value2.children) {
        value1.children.forEach((item1) => {
            value2.children.forEach(item2 => {
                if (item1.id == item2.id) {
                    item2.meta = item1.meta
                    if (item1.children && item2.children) {
                        item2 = changeMeta(item1, item2)
                    }
                }
            })
        })

    }
    return value2

}